// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2jrx4","Open":"SideDrawer_Open__3ilPL","Close":"SideDrawer_Close__3t47l","Logo":"SideDrawer_Logo__yyrRt"};